<template>
  <div class="rotate-overlay" role="dialog" aria-modal="true">
    <div class="rotate-card">
      <div class="rotate-icon" aria-hidden="true">
        <svg viewBox="0 0 64 64" width="64" height="64" fill="none">
          <rect
            x="18"
            y="8"
            width="28"
            height="48"
            rx="4"
            stroke="currentColor"
            stroke-width="3"
          />
          <path
            d="M10 32h8M46 32h8"
            stroke="currentColor"
            stroke-width="3"
            stroke-linecap="round"
          />
          <path
            d="M52 24v16M12 24v16"
            stroke="currentColor"
            stroke-width="3"
            stroke-linecap="round"
          />
        </svg>
      </div>
      <h1>{{ t('mobile.rotateTitle') }}</h1>
      <p>{{ t('mobile.rotateHint') }}</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '../i18n/t'

const { t } = useI18n()
</script>

<style scoped>
.rotate-overlay {
  position: fixed;
  inset: 0;
  z-index: 800;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: max(16px, env(safe-area-inset-top))
    max(16px, env(safe-area-inset-right))
    max(16px, env(safe-area-inset-bottom))
    max(16px, env(safe-area-inset-left));
  background: rgba(15, 23, 42, 0.96);
  color: #e2e8f0;
}

.rotate-card {
  max-width: 320px;
  text-align: center;
}

.rotate-icon {
  color: #e8c547;
  margin-bottom: 12px;
}

h1 {
  margin: 0 0 8px;
  font-size: 22px;
  font-weight: 700;
}

p {
  margin: 0;
  color: #94a3b8;
  font-size: 15px;
  line-height: 1.4;
}
</style>
